module.exports = __webpack_public_path__ + "img/question.79b6d8b3.svg";